import React from "react";
function AppointmentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 133"
      width="160"
      height="133"
      opacity="0.7"
    >
      {/* Background circle */}
      <circle cx="80" cy="67" r="40" fill="#F5F7F9" />

      {/* Back appointment block */}
      <g transform="translate(35, 43)">
        {/* Shadow */}
        <rect
          x="1.3"
          y="1.3"
          width="73"
          height="30"
          rx="4"
          fill="#0677ff"
          opacity="0.2"
        />
        {/* Main block */}
        <rect x="0" y="0" width="73" height="30" rx="4" fill="#EDF8FF" />
        {/* Duration icon */}
        <circle
          cx="13"
          cy="15"
          r="5.3"
          fill="none"
          stroke="#0063ff"
          strokeWidth="1.3"
          opacity="0.3"
        />
        {/* Clock hand */}
        <path
          d="M13 15 L13 11"
          stroke="#0063ff"
          strokeWidth="1.3"
          opacity="0.3"
        />
        {/* Content lines */}
        <rect
          x="27"
          y="10"
          width="40"
          height="2"
          rx="1"
          fill="#0063ff"
          opacity="0.3"
        />
        <rect
          x="27"
          y="17"
          width="27"
          height="2"
          rx="1"
          fill="#0063ff"
          opacity="0.3"
        />
      </g>

      {/* Middle appointment block */}
      <g transform="translate(42, 57)">
        {/* Shadow */}
        <rect
          x="1.3"
          y="1.3"
          width="73"
          height="30"
          rx="4"
          fill="#0677ff"
          opacity="0.2"
        />
        {/* Main block */}
        <rect x="0" y="0" width="73" height="30" rx="4" fill="#83D4FF" />
        {/* Duration icon */}
        <circle
          cx="13"
          cy="15"
          r="5.3"
          fill="none"
          stroke="#0063ff"
          strokeWidth="1.3"
          opacity="0.3"
        />
        {/* Clock hand */}
        <path
          d="M13 15 L13 11"
          stroke="#0063ff"
          strokeWidth="1.3"
          opacity="0.3"
        />
        {/* Content lines */}
        <rect
          x="27"
          y="10"
          width="40"
          height="2"
          rx="1"
          fill="#0063ff"
          opacity="0.3"
        />
        <rect
          x="27"
          y="17"
          width="27"
          height="2"
          rx="1"
          fill="#0063ff"
          opacity="0.3"
        />
      </g>

      {/* Front appointment block */}
      <g transform="translate(49, 70)">
        {/* Shadow */}
        <rect
          x="1.3"
          y="1.3"
          width="73"
          height="30"
          rx="4"
          fill="#0677ff"
          opacity="0.2"
        />
        {/* Main block */}
        <rect x="0" y="0" width="73" height="30" rx="4" fill="#0063ff" />
        {/* Duration icon */}
        <circle
          cx="13"
          cy="15"
          r="5.3"
          fill="none"
          stroke="#F5F7F9"
          strokeWidth="1.3"
          opacity="0.8"
        />
        {/* Clock hand */}
        <path
          d="M13 15 L13 11"
          stroke="#F5F7F9"
          strokeWidth="1.3"
          opacity="0.8"
        />
        {/* Content lines */}
        <rect
          x="27"
          y="10"
          width="40"
          height="2"
          rx="1"
          fill="#F5F7F9"
          opacity="0.7"
        />
        <rect
          x="27"
          y="17"
          width="27"
          height="2"
          rx="1"
          fill="#F5F7F9"
          opacity="0.5"
        />
      </g>
    </svg>
  );
}

export default AppointmentIcon;
